export default __webpack_public_path__ + "static/media/exoticquixotic.8893f4a1.svg";